import React from 'react';

const Socials = () => {

  return (
    <div className='social'>
        <i className="fa-brands fa-instagram fa-2xl"></i>
        <i className="fa-brands fa-linkedin fa-2xl"></i>
        <i className="fa-brands fa-github fa-2xl"></i>
    </div>
  );
}

export default Socials;
